import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { isGlobalFilterKey } from './useGlobalFilter';

export const useMessageQueuesFilters = (): string => {
  const [searchParams] = useSearchParams();

  const filteredParams = useMemo(() => {
    const params = new URLSearchParams();
    searchParams.forEach((value, key) => {
      if (!isGlobalFilterKey(key)) {
        params.append(key, value);
      }
    });
    return params.toString();
  }, [searchParams]);

  return filteredParams;
};
